import React, { useEffect } from 'react'
import { Home, HeadsetMic } from '@mui/icons-material'
import { Grid, Fab, Typography } from '@mui/material'
import { connect } from 'react-redux'
import * as common from '../../../appRedux/actions/common'
import * as info from '../../../appRedux/actions/info'
import IntlMessages from '../../../util/IntlMessages'
import * as router from '../../../constants/router'
import * as tools from '../../../util/tools'
import useStyles from './top_content.style'

function TopContent(props) {
    const classes = useStyles()
    let requestDetails = props.field.requestOnline

    useEffect(() => {
        props.getSupportNumberAction()
    }, [])

    return (
        <React.Fragment>
            <Grid container>
                <Grid item xs={4} md={4} className={classes.gridRight}>
                    <Fab size="medium" href={tools.telFormat(props.field.supportNumber)} style={{ backgroundColor: '#fff' }}>
                        <HeadsetMic />
                    </Fab>
                </Grid>
                <Grid item xs={4} md={4} >
                    <Grid className={classes.costRoot}>
                        <span className={classes.amount}>{<IntlMessages id="amount" />}</span>
                        <Typography variant="h5">
                            {tools.numberformat(requestDetails.price.iTotalPrice)}
                            <span className={classes.rial}>{<IntlMessages id="rials" />}</span>
                        </Typography>
                    </Grid>
                </Grid>
                <Grid item xs={4} md={4} className={classes.gridLeft}>
                    <Fab size="medium" onClick={() => props.redirectAction(router.HOME)} style={{ backgroundColor: '#fff' }}>
                        <Home />
                    </Fab>
                </Grid>
            </Grid>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
        field: state.field
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        redirectAction: (router) => dispatch(common.redirectAction(router)),
        getSupportNumberAction: () => dispatch(info.getSupportNumberAction())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TopContent)